import { initFormValidation } from '@/plugins/veevalidate'
import { setDayjsLocale } from '@/plugins/dayjs'
import localizationItemServerData from '@/common/services/serverData/localizationItemServerData'
import { useActivitiesStore } from '@/agent/stores/activitiesStore'
import { useSessionStore } from '@/common/stores/sessionStore'
import * as localeHelpers from '@/common/helpers/locale'
import { PrefixTranslationsEnum } from '@/common/types/i18n'

const updateLocaleSettings = async (locale: string, localeLanguage: string) => {
  await Promise.all([
    localeHelpers.changeQuasarLanguage(locale),
    localizationItemServerData.fetch({
      prefixes: PrefixTranslationsEnum.ASSIST,
    }),
    setDayjsLocale(localeLanguage),
  ])
  initFormValidation(localeLanguage)
}

export const initAppSessionSettings = async () => {
  const sessionStore = useSessionStore()
  const activities = useActivitiesStore()

  try {
    await sessionStore.loadSessionSettings()

    if (sessionStore.locale) {
      await updateLocaleSettings(sessionStore.locale, sessionStore.localeLanguage)
    }

    await activities.fetchAgentActivities()
  } catch (error) {
    console.error(error)
  }
}
